// Angular
import {Component,ChangeDetectorRef, ElementRef, ViewChild} from '@angular/core';
// Layout
import {LayoutConfigService, OffcanvasOptions} from '../../../../core/_base/layout';
import {Router, ActivatedRoute} from "@angular/router";
import {environment} from '../../../../../environments/environment';
import {HistoryClass} from '../../../../Class/common/history/history-class';
import {HistoryService} from '../../../../Service/common/history/history-service.service';
import { ADM0009Class } from '../../../../Class/ADM0009/adm0009-class';
import { ADM0009ServiceService } from '../../../../Service/ADM0009/adm0009-service.service';
import { ADM0008Class } from '../../../../Class/ADM0008/adm0008-class';
import { ADM0008ServiceService } from '../../../../Service/ADM0008/adm0008-service.service';
import { Da5100Class } from '../../../../Class/da5100/da5100-class';
import { Da5100Service } from '../../../../Service/da5100/da5100-service.service';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import {DatePipe} from '@angular/common';
import { Ba1300Class } from '../../../../Class/ba1300/ba1300-class';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { formatDate } from '@angular/common';
import { MatPaginator, MatSort, MatSnackBar, MatDialog, MatTableDataSource } from '@angular/material';
//import * as moment from 'moment-timezone';
import { HttpClient } from '@angular/common/http';
import { toNumber } from 'lodash';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { NotificationDatailsComponent } from '../notification-details/notification-datails.component';
import { Widget0004Component } from '../../../../views/pages/widget/widget-dashboard/widget0004/widget0004.component';

import { interval, Subscription } from 'rxjs';
import { switchMap,startWith } from 'rxjs/operators';
import { DashboardDataServiceService } from '../../../../Service/DashboardData/dashboard-data-service.service';
import { Console } from 'console';
import { NavigationEnd} from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'kt-sticky-toolbar',
	templateUrl: './sticky-toolbar.component.html',
	styleUrls: ['./sticky-toolbar.component.scss'],
	providers: [DatePipe]
})
export class StickyToolbarComponent {
@ViewChild('chatContainer', { static: false }) chatContainer: ElementRef;
	dataSource=new MatTableDataSource<Da5100Class>();
	dataSource2=new MatTableDataSource<Da5100Class>();
	displayedColumns = ['InTime', 'OutTime'];
	private HistoryList: Array<any> = [];
	latLong:any;
	showApprovalPanel = false;
	currentUrl:string;
	photoURL:string;
	pendingNotificationCount:number;
	groupedMessages: any[] = [];
	totalUnreadCount: number = 0;

	latitude:any;
	longitude:any;
	result1:any;
	result2:any;
	unreadUsers: number[] = [];
	buttonColor = '#002F63';
	colorRed="#cc0000";
	checkintime:string;
	EmployeeSelected:Ba1300Class;
	Form:FormGroup;
	currentTime: Date;
	formattedDate:string;
	isDisabled = false; 
	iDisabled:boolean;
	currentUser: any = '';
	h:string;
	ctime:string;
	watchId:number;
	Da5100List:any[];
	s:string;
	n:string;
	intime:any;
	outtime:any;
	sample:string;
	vision:string;
	currentDate = new Date();
	strCheckedIn:string;
	isButtonVisibleCheckIn = true;
	isButtonVisibleCheckOut = false;
	result:string;	
	longitudeLocation:number;	
	lat:any;
	long:any;
	formattedTime:any;
	Currentdate:string;
	currentTimeZone:any;
	time:string;
	latitudeLocation:number;
	apiKey = 'AIzaSyAdJMtlaePAzjgdF0Kkn6aRL6OddgtEXNk';	
	current:string;
	dialogRef:any;
	isLocationVisible=false;
	AsOnDate:string;
	dateVisible=false;
	AttendanceTodayVisible=false;
	totalPendingCount: number = 0;
	refreshSub: Subscription;  // declare at class level
	unreadMap: any = {};   // 🔥 key = empId, value = count


	employees: any[] = [];
filteredEmployees: any[] = [];

selectedUser: any = null;
messages: any[] = [];

searchText = '';
newMessage = '';

	// Public properties
	demoPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_demo_panel_close',
		toggleBy: 'kt_demo_panel_toggle',
	};

	loginPanelOptions1: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_login_panel_close',
		toggleBy: 'kt_login_panel_toggle',
	};

	notificationPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_notification_panel_close',
		toggleBy: 'kt_notification_panel_toggle',
	};

	chatPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_chat_panel_close',
		toggleBy: 'kt_chat_panel_toggle',
	};

	favoritesPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_favorites_panel_close',
		toggleBy: 'kt_favorites_panel_toggle',
	};

	approvalPanelOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'kt-demo-panel',
    closeBy: 'kt_approval_panel_close',
    toggleBy: 'kt_approval_panel_toggle',
};

ApprovalList: Array<any> = [];

	lblbtn:string;
	baseHref: string;
	parentPath: string;
	tblNotificationDetailsArray :Array<any>=[];
	tblNotificatioExpandArray :Array<any>=[];
	tblOtherDocDetailsRowIndex : number;
	tblOtherDocDetailsArray :Array<any>=[];
    tblOtherDocDetailsReportRowIndex : number;
	tblOtherDocDetailsReportArray :Array<any>=[];
	ReadMore :boolean=true;
	visible:boolean=false;
	objNotification = new ADM0009Class();
	audio: HTMLAudioElement;
	audioInitialized: boolean = false;
	currentPath:string;
	// audio = new Audio('./assets/sounds/mixkit-software-interface-start-2574.wav'); // 🔔 path to sound file

	tabs = ['Screens', 'Reports'];
	selectedtab = this.tabs[0];


	// ===== Web attendance state (new) =====
	isProcessing = false;      // a punch is in progress
	isLoadingState = false;    // drawer is loading its first state
	statusText = '';
	private geoOptions = { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 };



	constructor(
			public dialog: MatDialog,private http: HttpClient,private datePipe: DatePipe,private route: ActivatedRoute,private formBuilder: FormBuilder, private layoutUtilsService: LayoutUtilsService,private attendanceservice:Da5100Service, private layoutConfigService: LayoutConfigService, private objHistoryService: HistoryService, private router: Router, private changeDetectorRef: ChangeDetectorRef, private activatedRoute: ActivatedRoute,private ADM0008service:ADM0008ServiceService,private ADM0009service:ADM0009ServiceService,private dashboardService: DashboardDataServiceService ) {
		this.baseHref = 'https://keenthemes.com/metronic/preview/angular/';
	}
ngOnInit() {
	//this.loadEmployees();

  // ✅ Check the current URL immediately (covers the case where
  // this component initializes AFTER the relevant NavigationEnd already fired)
  this.showApprovalPanel = this.router.url.includes('da5010-new');

  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.showApprovalPanel = event.urlAfterRedirects.includes('da5010-new');
      this.changeDetectorRef.detectChanges();
    });
	this.currentUrl =  environment.baseUrl.replace("api/", "");
    this.photoURL = "UploadFiles/DocManager/Default/photo.png";

	  if(localStorage.getItem('currentUser') != null)
    {
      var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser=  userLoginDetails.UserId;
    }

   this.activatedRoute.parent.url.subscribe(p => {
			this.parentPath = p[p.length - 1].path
		})

		this.Form = this.formBuilder.group({
			AttendanceId: [0]
		})
  this.audio = new Audio('assets/sound/mixkit-software-interface-start-2574.wav');
  this.audio.preload = 'auto';
  this.audio.volume = 0; // first click volume 0 to unlock

  // Unlock audio on first user interaction
  const unlockAudio = () => {
    this.audio.play().then(() => {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audioInitialized = true;
      console.log('Audio initialized! Ready to play notifications.');
    }).catch(err => console.warn('Audio init blocked:', err));

    window.removeEventListener('click', unlockAudio);
  };
  window.addEventListener('click', unlockAudio);

 // Call immediately once, then every 10 seconds
//   this.refreshSub = interval(10000)
//     .pipe(
//       startWith(0), // ✅ triggers immediately on subscription
//       switchMap(() => this.ADM0009service.LoadFind())
//     )
//     .subscribe(data => {
//       const tblNotificationDetailsArray = data.objADM0009CountList as ADM0009Class[];
//       const newCount = tblNotificationDetailsArray.reduce((sum, item) => sum + (item.PendingCount || 0), 0);

//       // Only play if user has interacted and audio is initialized
//       if (this.audioInitialized && newCount > this.totalPendingCount) {
//         // this.playNotificationSound();

		
//       }

// 	 const Count= data.ADM0009EntityCount.reduce((sum, item) => sum + (item.PendingCount || 0),0);

// 	  // ✅ SHARE VALUE HERE
//       this.dashboardService.setPendingCount(Count);

//       this.totalPendingCount = newCount;

// 	    // ===========================
//     // ✅ NEW UNREAD COUNT LOGIC
//     // ===========================
//     this.ADM0009service.getUnread().subscribe(res => {

//       const unreadList = res.UnreadList || [];

//       this.totalUnreadCount = unreadList.reduce(
//         (sum, item) => sum + (item.UnreadCount || 0),
//         0
//       );
// 	   this.changeDetectorRef.detectChanges();
//     });
// 	      if (this.audioInitialized && newCount > this.totalUnreadCount) {
//         // this.playNotificationSound();

		
//       }
//       this.changeDetectorRef.detectChanges();
//     });
	this.isLocationVisible=false;
}

playNotificationSound() {
  if (!this.audioInitialized) {
    console.log('Audio not initialized yet. Waiting for user interaction.');
    return;
  }

  this.audio.volume = 1; // set full volume
  this.audio.currentTime = 0;
  this.audio.play().catch(err => console.log('Audio play blocked:', err));
}

	isActiveDemo(demo) {

		return demo === this.layoutConfigService.getConfig('demo');
	}

	onClick(field)
	{
		if (this.dialogRef) {
    		this.dialogRef.close();
		}

	//	this.dialogRef1.close(`${""}`);
		this.objNotification= new ADM0009Class();
		this.objNotification.CategeoryName =field.CategeoryName;	
		this.objNotification.NotificationId =field.NotificationIds;
		this.objNotification.CategoryId =field.CategoryId;
		this.dialogRef=this.dialog.open(NotificationDatailsComponent, {
			width: '700px',height:'600px',
			data:this.objNotification,
			panelClass: 'custom-dialog-animation' // 👈 Add this line
		  }); 		
	}

	tblOtherDocDetailsEdit(field){
		var url = field.PageUrl;
  
		this.router.navigate([url], { queryParams: { } });   
		this.changeDetectorRef.detectChanges();
		}
	  
		tblOtherDocDetailsReportEdit(field){
		 
		  var url = field.PageUrl;
  
		  this.router.navigate([url], { queryParams: { } });   
		  this.changeDetectorRef.detectChanges();
			}

			tblOtherDocDetailsRemove(field){
			
			  this.tblOtherDocDetailsRowIndex=null;
			  const index = this.tblOtherDocDetailsArray.indexOf(field);
			 var id=field.FavoriteId;
  
			  this.ADM0008service.Delete(id).subscribe(data=>{
				if(data)
				{
				  
				}
			  });
		   
			  this.tblOtherDocDetailsArray.splice(index,1);
		
			  this.changeDetectorRef.detectChanges();
			}
			tblOtherDocDetailsRemoveReport(field){
			 
			  this.tblOtherDocDetailsReportRowIndex=null;
			  const index = this.tblOtherDocDetailsReportArray.indexOf(field);
			  var id=field.FavoriteId;
			  this.ADM0008service.Delete(id).subscribe(data=>{
				
			  });
		 
			  this.tblOtherDocDetailsReportArray.splice(index,1);
		
			  this.changeDetectorRef.detectChanges();
			}

	onLoadNotification()
	{
			this.ADM0009service.LoadFind().subscribe(data=>{   
			this.tblNotificationDetailsArray = data.objADM0009CountList as ADM0009Class[];    
			  this.totalPendingCount = this.tblNotificationDetailsArray
            .reduce((sum, item) => sum + (item.PendingCount || 0), 0);
			this.changeDetectorRef.detectChanges();
			})
	}

	onLoadFavorates()
	{

	  this.ADM0008service.LoadFind().subscribe(data=>{     
	  this.tblOtherDocDetailsArray = data.ADM0008List as ADM0008Class[];     
	  this.tblOtherDocDetailsReportArray = data.ADM0008ListReport as ADM0008Class[];     
	  this.changeDetectorRef.detectChanges();
	  })
	
	}
	GoBackToActiveData(){
		this.router.navigateByUrl(environment.activeUrl);
	}

	ShowHistoryList(){
		this.HistoryList.splice(0);
	


		if(environment.activeUrl != "")
		{
	
			var strHtml = "";
			var objHistoryClass = new HistoryClass();
			objHistoryClass.activeUrl = environment.activeUrl;
			objHistoryClass.activePageName = environment.activePageName;
			objHistoryClass.activeUniqueId = environment.activeUniqueId;
		
			this.objHistoryService.ShowHistoryList(objHistoryClass).subscribe(data=>{
				this.HistoryList = data;
				this.changeDetectorRef.detectChanges();
			})

			document.getElementById('btnGoBack').style.display = 'block';
			document.getElementById('btnNa').style.display = 'none';
		}
		else
		{
			document.getElementById('btnGoBack').style.display = 'none';
			document.getElementById('btnNa').style.display = 'block';
		}
	}
  
	doFindHistory(MdfdBy, MdfdOn){
		var Url = environment.activeUrl+"&MdfdBy=" + MdfdBy + "&MdfdOn=" + MdfdOn + "";
		this.router.navigateByUrl(Url);
	}

	checkin()
	{
		this.isDisabled=true;

		if (!navigator.geolocation)
		{
		console.log('Location is not supported');
		return;
		}
		
	
		var classobj=new Da5100Class();
		navigator.geolocation.getCurrentPosition((position) => {
	
			const coords = position.coords;	
			console.log(coords)		
			this.latitude=position.coords.latitude;
			this.longitude=position.coords.longitude;})
			classobj.coordinatelat=toNumber(this.latitude);
			classobj.coordinatelong=toNumber(this.longitude);
			if(this.latitude==null && this.longitude==null){

				this.layoutUtilsService.showActionNotification("Cannot Access Your Location", MessageType.Read, 2500, true, false, 2500, "bottom")
				this.isDisabled=false;
			}

		this.currentTime = new Date();
		//this.formattedDate = this.currentDate.toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' });
		this.formattedDate =this.datePipe.transform(this.currentTime,"hh:mm a")
		var classobj=new Da5100Class();
		classobj.AttendanceId = this.Form.controls["AttendanceId"].value;
		classobj.coordinatelat=toNumber(this.latitude);
		classobj.coordinatelong=toNumber(this.longitude);
		classobj.Remarks=this.result;
	
		//classobj.InTime= this.formattedDate;
		this.attendanceservice.Insert(classobj).subscribe(data=>{
			if(data.IsSuccess)
		{
			this.attendanceservice.load(classobj).subscribe(data=>
				{	 
					if(data.Da5100Header != null)
					{
						this.isButtonVisibleCheckIn = false;
						this.isButtonVisibleCheckOut = true;	
						this.strCheckedIn = "Check In Time : " + data.Da5100Header.InTime;
						this.changeDetectorRef.detectChanges();
					}
			
				
					this.dataSource.data= data.Da5100List;
				})
								
		this.changeDetectorRef.detectChanges();
		}
		})		
		this.changeDetectorRef.detectChanges();			
		
	}


		  
 onGetDatas() 
 {
	    var classobj=new Da5100Class();
		this.isButtonVisibleCheckIn = false;
		navigator.geolocation.getCurrentPosition((position) => {
		 // This callback runs once the user grants location access
		 const coords = position.coords;
		 console.log(coords);
	 
		 // Assign the coordinates
		 this.latitude = coords.latitude;
		 this.longitude = coords.longitude;
	 
		 // Assign the coordinates to the class object
		 classobj.coordinatelat = toNumber(this.latitude);
		 classobj.coordinatelong = toNumber(this.longitude);
	 
		 // Ensure no NaN values
		 if (Number.isNaN(classobj.coordinatelat) || Number.isNaN(classobj.coordinatelong)) {
			this.layoutUtilsService.showActionNotification("Cannot Access Your Location", MessageType.Read, 2500, true, false, 2500, "bottom")		 
		 } else {
		   console.log("Coordinates successfully fetched:", classobj);
		   this.attendanceservice.load(classobj).subscribe(data=>
			{	 
				if(data.Da5100Header != null)
				{
					//this.isButtonVisibleCheckIn = false;
					this.isButtonVisibleCheckOut = true;	
					this.strCheckedIn = "Check In Time : " + data.Da5100Header.InTime;
					this.changeDetectorRef.detectChanges();
				}
				else{
					this.isButtonVisibleCheckIn = true;
				}	
				   this.dataSource.data= data.Da5100List;
		
					if(data.Da5100check.length!=0)
					{					
						this.dateVisible=true;
						this.AsOnDate=data.Da5100check[0].strLastCheckinDate;
					}
					else{
						this.dateVisible=false;		
					}
					this.AttendanceTodayVisible=true;
					this.dataSource2.data= data.Da5100check;
					this.changeDetectorRef.detectChanges();
				})
		   // Proceed with additional logic here
		 }})
		this.currentTime = new Date();  	
		classobj.coordinatelat=toNumber(this.latitude);
		classobj.coordinatelong=toNumber(this.longitude);	
	
}

checkout(){
	var classobj=new Da5100Class();
	navigator.geolocation.getCurrentPosition((position) => {
	const coords = position.coords;			
	this.latitude=position.coords.latitude;
	this.longitude=position.coords.longitude;})		
	classobj.coordinatelat=this.latitude;
	classobj.coordinatelong=this.longitude;

	classobj.OutTime=this.formattedDate;
	this.attendanceservice.update(classobj).subscribe(data=>{
		if(data.IsSuccess)
		{
			this.isDisabled=false;			
			this.isButtonVisibleCheckIn = true;
			this.isButtonVisibleCheckOut = false;	
			this.strCheckedIn="";
			this.onGetDatas();
			var classobj=new Da5100Class();
			this.attendanceservice.load(classobj).subscribe(data=>
			{	 
				if(data.Da5100check != null)
				{					
					// this.isButtonVisibleCheckIn = false;
					// this.isButtonVisibleCheckOut = true;	
					// this.strCheckedIn = "Check In Time : " + data.Da5100Header.InTime;
					// this.changeDetectorRef.detectChanges();
				}
			
			
				this.dataSource2.data= data.Da5100check;
			})
			this.changeDetectorRef.detectChanges();
		}	
})
}

deg2rad(angle_in_degrees: number): number 
{
	return angle_in_degrees * (Math.PI / 180);
}
getlocation(){
	navigator.geolocation.getCurrentPosition((position) => {
		const coords = position.coords;	
		console.log(coords)		
		this.latitudeLocation=position.coords.latitude;
		this.longitudeLocation=position.coords.longitude;
		this.isLocationVisible=true;
		this.changeDetectorRef.detectChanges();
	})
}

ngOnDestroy() {
  if (this.refreshSub) {
    this.refreshSub.unsubscribe();
  }
}


loadEmployees() {
  this.employees = [];
this.ADM0009service.LoadFind().subscribe(data=>{   
    // 🔥 STORE FULL LIST
    this.employees = data.UsersList || [];

    // 🔥 SHOW ONLY FIRST 15
    this.filteredEmployees = this.employees.slice(0, 15);
	this.loadUnreadChats();
  

}
)
  
}


// loadUnreadChats() {
//   this.ADM0009service.getUnread().subscribe(res => {
// debugger
//     this.unreadMap = {};

//     if (res && res.UnreadList) {
//       res.UnreadList.forEach(x => {
//         this.unreadMap[x.CrtdBy] = x.UnreadCount;
//       });
// 	  console.log('Unread Map:', this.unreadMap);
//     }
//   });
// }

loadUnreadChats() {
  this.ADM0009service.getUnread().subscribe(res => {

    this.unreadMap = {};

    if (res && res.UnreadList) {
      res.UnreadList.forEach(x => {
        this.unreadMap[x.CrtdBy] = x.UnreadCount;
      });
    }

    // 🔥 SORT USERS → unread first
    this.filteredEmployees = this.filteredEmployees.sort((a, b) => {
      const aUnread = this.unreadMap[a.UserId] || 0;
      const bUnread = this.unreadMap[b.UserId] || 0;

      return bUnread - aUnread; // descending
    });

  });
}

// filterEmployees() {

//   if (!this.searchText) {
//     this.filteredEmployees = this.employees.slice(0, 15);
//     return;
//   }

//   this.filteredEmployees = this.employees
//     .filter(emp =>
//       emp.EmployeeName.toLowerCase().includes(this.searchText.toLowerCase())
//     )
//     .slice(0, 15);
// }

filterEmployees() {

  if (!this.searchText) {
    this.filteredEmployees = this.employees.slice(0, 15);
  } else {
    this.filteredEmployees = this.employees
      .filter(emp =>
        emp.EmployeeName.toLowerCase().includes(this.searchText.toLowerCase())
      )
      .slice(0, 15);
  }

  // 🔥 KEEP UNREAD ON TOP EVEN AFTER SEARCH
  this.filteredEmployees = this.filteredEmployees.sort((a, b) => {
    const aUnread = this.unreadMap[a.UserId] || 0;
    const bUnread = this.unreadMap[b.UserId] || 0;

    return bUnread - aUnread;
  });
}
selectUser(user: any) {
  this.selectedUser = user;

  this.loadMessages(user.UserId);
  this.loadUnreadChats(); // 🔥 refresh badge count for selected user
// this.markAsRead(user.UserId);
}
// markAsRead(empId: number) {
//   const payload = {
//     toUserId: empId
//   };

//   this.ADM0009service.markAsRead(payload).subscribe(() => {
//     this.loadUnreadChats(); // 🔥 refresh badge
//   });
// }
loadMessages(userId: number) {
  const payload = {
    toUserId: userId
  };

  this.ADM0009service.loadMessages(payload).subscribe(res => {

	  // 🔥 STORE RESPONSE
this.messages = res.ChatList.map(x => ({
  id: x.NotificationId,
  text: x.message,
  isDeleted: x.RecStatus == 1,
  date: new Date(x.CrtdOn),   // 🔥 ADD THIS
  time: this.formatTime(x.CrtdOn),
  type: Number(x.CrtdBy) === Number(this.currentUser) ? 'sent' : 'received',
  readFlag: x.ReadFlag
}));

this.groupMessagesByDate();  // 🔥 IMPORTANT
this.scrollToBottom(); // ✅ ADD HERE
this.changeDetectorRef.detectChanges();
    // this.loadUnreadChats(); // 🔥 refresh badge
  });
  this.changeDetectorRef.detectChanges();
}
sendMessage() {

  if (!this.newMessage || !this.selectedUser) return;

  const msg = {
    text: this.newMessage,
   time: new Date().toLocaleTimeString('en-IN', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
}),
    type: 'sent'
  };

  // UI update
  this.messages.push(msg);
this.scrollToBottom(); // ✅ ADD HERE
  // 🔥 API CALL
  this.sendMessageToServer(this.selectedUser.UserId, this.newMessage);

  this.newMessage = '';
}
sendMessageToServer(userId: number, message: string) {

  const payload = {
    toUserId: userId,
    message: message
  };

  this.ADM0009service.sendMessage(payload).subscribe(data=>{   
this.loadMessages(this.selectedUser.UserId);
 this.changeDetectorRef.detectChanges();
}
)

}

deleteMessage(notificationId: number) {

//   if (!confirm('Delete this message?')) return;

  const payload = {
    NotificationId: notificationId
  };

  this.ADM0009service.deleteMessage(payload).subscribe(res => {
	this.loadMessages(this.selectedUser.UserId);

    // ✅ remove from UI instantly
    // this.messages = this.messages.filter(m => m.id !== notificationId);

  });

}

groupMessagesByDate() {
  this.groupedMessages = [];

  let lastDate = '';

  this.messages.forEach(msg => {
    const msgDate = this.formatDateHeader(msg.date);

    if (msgDate !== lastDate) {
      this.groupedMessages.push({
        type: 'date',
        label: msgDate
      });
      lastDate = msgDate;
    }

    this.groupedMessages.push({
      type: 'message',
      data: msg
    });
  });
}
formatDateHeader(date: Date): string {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const d = new Date(date);

  if (d.toDateString() === today.toDateString()) {
    return 'Today';
  }

  if (d.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  }

  return d.toLocaleDateString('en-IN', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
}
formatTime(date: any): string {
  if (!date) return '';

  return new Date(date).toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

scrollToBottom() {
  try {
    setTimeout(() => {
      const el = this.chatContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    }, 50); // small delay for DOM render
  } catch (err) {}
}

onLoadApprovals(transactionId: number) {
	this.ApprovalList=[];
	// alert(environment.activePageName,)
	// alert(environment.activeUniqueId,)
    const payload = { TransactionId: environment.activeUniqueId || transactionId };

    this.ADM0009service.GetApprovalTimeline(payload).subscribe(data => {

        this.ApprovalList = (data.TimelineList || []).map(item => {
            const isApprovalStep = item.StatusText === 'Approved'
                || item.StatusText === 'Rejected'
                || item.StatusText === 'Pending';

            return {
                EmployeeName: item.ActorName,
                Designation: item.ActorDesignation,
                EmpNo: item.ActorEmpNo,
                PhotoURL: item.ActorPhotoURL,
                Status: item.StatusText,
                Seq: isApprovalStep ? item.DecisionLevel : null,   // 🔥 level, not a running counter
                ActionDateStr: this.datePipe.transform(item.ActionOn, 'EEE, dd MMM'),
                ActionTimeStr: this.datePipe.transform(item.ActionOn, 'hh:mm a')
            };
        });

        this.changeDetectorRef.detectChanges();
    });
}




// ================= WEB ATTENDANCE (biometricdevicelogs) =================

private getPositionWeb(): Promise<any> {
	return new Promise((resolve, reject) => {
		if (!navigator.geolocation) { reject(new Error('unsupported')); return; }
		navigator.geolocation.getCurrentPosition(resolve, reject, this.geoOptions);
	});
}

private locationErrorWeb() {
	this.layoutUtilsService.showActionNotification(
		"Cannot Access Your Location. Please allow location access in your browser settings.",
		MessageType.Read, 3500, true, false, 3500, "bottom");
	this.isProcessing = false;
	this.isLoadingState = false;
	this.statusText = '';
	this.changeDetectorRef.detectChanges();
}

private punchErrorWeb(data: any, fallback: string) {
	const msg = data && data.ErrorCodes && data.ErrorCodes.length ? data.ErrorCodes[0] : fallback;
	this.layoutUtilsService.showActionNotification(msg, MessageType.Read, 2500, true, false, 2500, "bottom");
	this.isProcessing = false;
	this.isLoadingState = false;
	this.statusText = '';
	this.changeDetectorRef.detectChanges();
}

// Loads current state from the server using coordinates we already have
private refreshAttendanceWeb() {
	const obj = new Da5100Class();
	obj.coordinatelat = Number(this.latitude);
	obj.coordinatelong = Number(this.longitude);

	this.attendanceservice.loadWeb(obj).subscribe(data => {
		const open = data.Da5100Header != null;
		this.isButtonVisibleCheckOut = open;
		this.isButtonVisibleCheckIn = !open;
		this.strCheckedIn = open ? "Check In Time : " + data.Da5100Header.InTime : "";

		this.dataSource.data = data.Da5100List || [];
		const last = data.Da5100check || [];
		this.dataSource2.data = last;
		this.dateVisible = last.length !== 0;
		if (this.dateVisible) { this.AsOnDate = last[0].strLastCheckinDate; }
		this.AttendanceTodayVisible = true;

		this.isLoadingState = false;
		this.isProcessing = false;
		this.statusText = '';
		this.changeDetectorRef.detectChanges();
	}, () => this.punchErrorWeb(null, "Could not load attendance"));
}

// Called when the Login drawer icon is clicked
onGetDatasWeb() {
	this.isLoadingState = true;
	this.statusText = 'Getting your location...';
	this.changeDetectorRef.detectChanges();

	this.getPositionWeb().then(pos => {
		this.latitude = pos.coords.latitude;
		this.longitude = pos.coords.longitude;
		this.statusText = 'Loading attendance...';
		this.changeDetectorRef.detectChanges();
		this.refreshAttendanceWeb();
	}).catch(() => this.locationErrorWeb());
}

checkinWeb() {
	if (this.isProcessing) { return; }
	this.isProcessing = true;
	this.statusText = 'Getting your location...';
	this.changeDetectorRef.detectChanges();

	this.getPositionWeb().then(pos => {
		this.latitude = pos.coords.latitude;
		this.longitude = pos.coords.longitude;
		this.statusText = 'Checking in...';
		this.changeDetectorRef.detectChanges();

		const obj = new Da5100Class();
		obj.AttendanceId = this.Form.controls["AttendanceId"].value;
		obj.coordinatelat = Number(this.latitude);
		obj.coordinatelong = Number(this.longitude);

		this.attendanceservice.checkinWeb(obj).subscribe(data => {
			if (data.IsSuccess) {
				// flip immediately, then sync with the server in the background
				this.isButtonVisibleCheckIn = false;
				this.isButtonVisibleCheckOut = true;
				this.strCheckedIn = "Check In Time : " + this.datePipe.transform(new Date(), 'dd/MM/yyyy , hh:mm a');
				this.isProcessing = false;
				this.statusText = '';
				this.changeDetectorRef.detectChanges();
				this.refreshAttendanceWeb();
			} else {
				this.punchErrorWeb(data, "Check In failed");
			}
		}, () => this.punchErrorWeb(null, "Check In failed"));
	}).catch(() => this.locationErrorWeb());
}

checkoutWeb() {
	if (this.isProcessing) { return; }
	this.isProcessing = true;
	this.statusText = 'Getting your location...';
	this.changeDetectorRef.detectChanges();

	this.getPositionWeb().then(pos => {
		this.latitude = pos.coords.latitude;
		this.longitude = pos.coords.longitude;
		this.statusText = 'Checking out...';
		this.changeDetectorRef.detectChanges();

		const obj = new Da5100Class();
		obj.coordinatelat = Number(this.latitude);
		obj.coordinatelong = Number(this.longitude);

		this.attendanceservice.checkoutWeb(obj).subscribe(data => {
			if (data.IsSuccess) {
				this.isButtonVisibleCheckOut = false;
				this.isButtonVisibleCheckIn = true;
				this.strCheckedIn = "";
				this.isProcessing = false;
				this.statusText = '';
				this.changeDetectorRef.detectChanges();
				this.refreshAttendanceWeb();   // no second geolocation call
			} else {
				this.punchErrorWeb(data, "Check Out failed");
			}
		}, () => this.punchErrorWeb(null, "Check Out failed"));
	}).catch(() => this.locationErrorWeb());
}




punchTime(s: string): string {
	if (!s) { return ''; }
	const parts = s.split(',');
	return parts[parts.length - 1].trim();
}


punchDate(s: string): string {
	if (!s) { return ''; }
	return s.split(',')[0].trim();
}

private parsePunch(s: string): Date | null {
	if (!s) { return null; }
	const m = s.match(/(\d{2})\/(\d{2})\/(\d{4})\s*,\s*(\d{1,2}):(\d{2})\s*(AM|PM)/i);
	if (!m) { return null; }
	let h = (+m[4]) % 12;
	if (m[6].toUpperCase() === 'PM') { h += 12; }
	return new Date(+m[3], +m[2] - 1, +m[1], h, +m[5]);
}


duration(inS: string, outS: string): string {
	const a = this.parsePunch(inS);
	const b = this.parsePunch(outS);
	if (!a || !b) { return '-'; }
	const mins = Math.max(0, Math.round((b.getTime() - a.getTime()) / 60000));
	return Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
}


}
